// Countdown in the PDP campaign banner (snippets/pdp-campaign-banner.liquid). Liquid renders
// the starting numbers, so this only keeps them ticking. When the date passes the whole
// banner goes, since its art is about the countdown.
if (!customElements.get('pdp-campaign-countdown')) {
  customElements.define(
    'pdp-campaign-countdown',
    class PdpCampaignCountdown extends HTMLElement {
      connectedCallback() {
        this.endsAt = new Date(this.dataset.date).getTime();
        if (Number.isNaN(this.endsAt)) return;
        this.units = this.querySelectorAll('[data-unit]');
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const left = Math.floor((this.endsAt - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(this.interval);
          this.closest('.pdp-campaign-banner')?.remove();
          return;
        }
        const values = {
          days: Math.floor(left / 86400),
          hours: Math.floor(left / 3600) % 24,
          mins: Math.floor(left / 60) % 60,
          secs: left % 60,
        };
        this.units.forEach((el) => {
          el.textContent = String(values[el.dataset.unit]).padStart(2, '0');
        });
      }
    }
  );
}
